import React, { Fragment, ReactNode } from 'react';
import ReactHintFactory from 'react-hint';
import { Badge } from 'components/common';
import { BoxEmpty } from 'components/common/box';
import { useReduxState } from 'hooks';

import type { BadgeCategory } from 'components/common/Badge';
import type { IconProp } from 'components/common/icons/Icon';

const ReactHint = ReactHintFactory(React);

interface Props {
  emptyMessage: string;
  id: string;
  items: {
    category: BadgeCategory;
    icon?: IconProp;
    title: string;
    tooltipContent?: ReactNode;
  }[];
}

const ProfileBadges = ({ emptyMessage, id, items }: Props) => {
  const renderContent = (item) => (
    <div
      className="vuo-tooltip__content"
      style={{ padding: '10px 15px', width: 200 }}
    >
      {item.tooltipContent}
    </div>
  );

  return (
    <div className="competencies">
      {items?.length ? (
        <div className="badges">
          {items.map((item, i) => (
            <Fragment key={i}>
              {item.tooltipContent ? (
                <ReactHint
                  attribute={`data-profile-badge-${id}-${i}`}
                  autoPosition={true}
                  className="vuo-tooltip-alt"
                  delay={50}
                  events={{ click: false, focus: false, hover: true }}
                  onRenderContent={() => renderContent(item)}
                  persist={true}
                />
              ) : null}
              <div className="badge">
                <Badge
                  category={item.category}
                  icon={item.icon}
                  isRounded={false}
                  style={{
                    cursor: 'default'
                  }}
                  text={item.title}
                  {...(item.tooltipContent
                    ? {
                        [`data-profile-badge-${id}-${i}`]: true
                      }
                    : {})}
                />
              </div>
            </Fragment>
          ))}
        </div>
      ) : (
        <BoxEmpty align="center" text={emptyMessage} />
      )}

      <style jsx>{`
        .badges {
          display: flex;
          flex-wrap: wrap;
          margin: 0 -5px -5px;
        }
        .badge {
          padding: 5px;
        }
      `}</style>
    </div>
  );
};

export default ProfileBadges;
